<template>
	<div id="g-recaptcha-tag"></div>
</template>

<script>
	import { mapMutations, mapActions } from 'vuex'

	export default {
		name: 'recaptcha',
		methods: {
			...mapActions(['publishTutorial']),
			...mapMutations(['setCaptchaResponse']),

			recaptchaCallback (response) {
				this.setCaptchaResponse(response)
				this.publishTutorial()
			}
		},
		created () {
			window.recaptchaCallback = this.recaptchaCallback
		}
	}
</script>

<style lang="scss">
	.grecaptcha-badge { display: none; }
</style>
